export function ProgressBar({ value = 0, color = "#FF5722", height = 10, showLabel = false }) {
  const pct = Math.max(0, Math.min(100, value));
  return (
    <div className="w-full">
      <div
        className="w-full rounded-full border-2 border-ink overflow-hidden bg-white"
        style={{ height }}
        data-testid="progress-track"
      >
        <div
          className="h-full rounded-full transition-all duration-500"
          style={{ width: `${pct}%`, background: color }}
          data-testid="progress-fill"
        />
      </div>
      {showLabel && (
        <div className="mt-1 text-xs font-semibold text-muted-foreground">{pct}%</div>
      )}
    </div>
  );
}
